module.exports = __webpack_public_path__ + "img/BH.7f3857cf.png";